export const ToTitleCase = (str) => {

    return str

        .toLowerCase()
        // handle snake_case, kebab-case, and spaces
        .split(/[_\s-]+/) 
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");

};